import { createFileRoute } from '@tanstack/react-router';
import { PropertiesCard } from './-components/PropertiesCard';

export const Route = createFileRoute('/_auth/dashboard/_layout/properties')({
  component: RouteComponent,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: null,
      }),
    };
  },
  head: () => {
    return {
      meta: [
        {
          title: 'Properties - OPAZ E-Service Portal',
        },
      ],
    };
  },
});

function RouteComponent() {
  return <PropertiesCard />;
}
